import api from "./api";
import { keyLocalStorage } from "helpers/constants";
import { User } from "models/users/type_user";

export type UserAccessResponse = {
  userId: string;
  roles: string[];
  permissions: string[];
  isSuperAdmin: boolean;
  canAccessPanel: boolean;
  rolesDetail?: Array<{
    id: string;
    type: string;
    description: string;
    permissions: Array<{ id: string; type: string; description: string }>;
  }>;
};

export function persistUserSession(user: User) {
  localStorage.setItem(keyLocalStorage.USER_STORAGE, JSON.stringify(user));
}

export function readUserSession(): User | null {
  try {
    const raw = localStorage.getItem(keyLocalStorage.USER_STORAGE);
    if (!raw) return null;
    return JSON.parse(raw) as User;
  } catch {
    return null;
  }
}

export function mergeUserWithAccess(
  user: Partial<User> & Pick<User, "id" | "access_token">,
  access: UserAccessResponse | null
): User {
  return {
    id: user.id,
    nome: user.nome ?? "",
    avatar: user.avatar ?? "",
    email: user.email ?? "",
    cpf: user.cpf,
    access_token: user.access_token,
    roles: access?.roles ?? user.roles ?? [],
    permissions: access?.permissions ?? user.permissions ?? [],
    isSuperAdmin: access?.isSuperAdmin ?? user.isSuperAdmin ?? false,
    canAccessPanel: access?.canAccessPanel ?? user.canAccessPanel ?? false,
  };
}

export async function getMyAccess(): Promise<UserAccessResponse | null> {
  try {
    const { data, status } = await api.get<UserAccessResponse>(
      "/users/me/access"
    );
    if (status >= 400 || !data?.userId) return null;
    return data;
  } catch {
    return null;
  }
}

/** Atualiza roles/permissões no storage e retorna usuário mesclado. */
export async function refreshUserAccess(): Promise<User | null> {
  const current = readUserSession();
  if (!current?.access_token) return null;

  const access = await getMyAccess();
  if (!access) return current;

  const merged = mergeUserWithAccess(current, access);
  persistUserSession(merged);
  return merged;
}
